import React, { Fragment, useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./../CustomedFields/FormikControl";
import { useParams } from "react-router-dom";
import CustomerAtMeasurementPage from "./CustomerAtMeasurementPage";
import measurementSettingsServices from "./../../services/measurementSettingsServices";
import DropDownBasic from "../CustomedUIComponents/DropDown/DropDownBasic";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const DDLmeasurementSettings = (props) => {
  // customerGUID
  const [mSettings, setMSettings] = useState([]);
  const [duckTap, setDuckTap] = useState("");
  const [title, setTitle] = useState("Product Measurement Settings");
  var measurementSettingsAll = [];

  useEffect(() => {
    //(1) search
    // debugger;
    const getMeasurementSettings = async () => {
      measurementSettingsAll =
        await measurementSettingsServices.getAllWithProductItemName();
      //alert(measurementSettingsAll[0].name);
      setMSettings(measurementSettingsAll);
      //   console.log(
      //     "searched Measurement Settings ----------> " +
      //       measurementSettingsAll.length
      //   );
    };

    getMeasurementSettings();
  }, [duckTap]);

  //(**) On product Item for Measurement select

  const onProductItemSelect = (
    selectedProductItemGUID,
    selectedProductItemName,
    slectedID,
    selectedValue,
    makingCharge
  ) => {
    // alert(slectedID + ", " + selectedValue);
    setTitle(selectedValue);
    props.ddlOnSelectFunction(
      selectedProductItemGUID,
      selectedProductItemName,
      slectedID,
      selectedValue,
      makingCharge
    );
  };

  return (
    <Fragment>
      <DropdownButton title={title}>
        {
          // alert(mSettings.length)
          mSettings.map((item) => (
            //alert(item.name)
            <Dropdown.Item
              key={item.measurementSettingsID_GUID}
              onClick={() => {
                onProductItemSelect(
                  item.productItemID_GUID,
                  item.productItemName,
                  item.measurementSettingsID_GUID,
                  item.name,
                  item.makingCharge,
                );
              }}  
            >
              {item.productItemName} - {item.name} - Charge({item.makingCharge})
            </Dropdown.Item>
          ))
        }
        {/* <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
      <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
      <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
      </DropdownButton>
    </Fragment>
  );
};

export default DDLmeasurementSettings;
